import React from 'react';

import { CartProvider } from '@/context/CartContext';
import { PromoProvider } from '@/context/PromoContext';

export const Root = (element: HTMLElement): JSX.Element => {
  return (
    <PromoProvider>
      <CartProvider>
        {/* <Fonts /> */}
        <>{element.children}</>
      </CartProvider>
    </PromoProvider>
  );
};
